import { useAuthUsername } from '@akin-home/auth/react';
import { useGetStateVariable as useGetStateVariableBase } from '@akin-home/state-variables-react';
import { assembleUserChatID } from '@akin-home/user';
import { UseQueryOptions } from 'react-query';
import { useApplicationID } from '../../chat/useAkinChat';
import { useCurrentUserID } from '../../users';

/** Wrapper for the base hook that injects the application_id and user details into the query */
export const useGetStateVariable = (
  name: string,
  options?: UseQueryOptions
) => {
  const id = useCurrentUserID();
  const username = useAuthUsername() || '';

  return useGetStateVariableBase(
    {
      application_id: useApplicationID(),
      username: assembleUserChatID(username, id),
      name,
    },
    options
  );
};
